import React, { useEffect } from 'react';
import Hls from 'hls.js';
import { groupSeek, setClientToSdk } from 'services/SyncService';
import HLSPlayerDecorator from 'services/SyncService/HLSPlayerDecorator';

// const STREAM = 'https://vn-public-krk-dmz.demo.synamedia.co.uk/content/hlsmp4/low-latency-rugby-hls/master.m3u8';
// const STREAM = 'https://demo-app.sceenic.co/football.m3u8';
// const STREAM = 'https://dev-stand.ru/media/video.m3u8';
const STREAM = 'https://media.itdevstand.com/hls/stream.m3u8';

function HLSPlayer({ isSyncRequired, isLoggedIn, componentStream }) {
  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const stream = urlParams.get('stream') || componentStream || STREAM;

    const $video = document.getElementById('player');
    const hls = new Hls({});
    window.player = hls;
    hls.attachMedia($video);

    hls.once(Hls.Events.MEDIA_ATTACHED, function () {
      hls.loadSource(stream);

      hls.once(Hls.Events.LEVEL_LOADED, function () {
        if (!isSyncRequired) {
          return;
        }
        setClientToSdk(new HLSPlayerDecorator(hls));
      });
    });

    $video.volume = 0.05;

    let firstSeek = true;
    $video.addEventListener('seeked', (e) => {
      if (!isSyncRequired) {
        return;
      }
      console.log('seeked');
      if (firstSeek) {
        firstSeek = false;
        return;
      }

      if (window.sdkSeek) {
        window.sdkSeek = false;
        return;
      }

      console.log('group seek');
      groupSeek();
    });

    return () => {
      hls.destroy();
    };
    // let waiting = null;
    // player.addEventListener('canplay', () => {
    //   clearTimeout(waiting);
    //   console.log('canplay');
    // });
    // player.addEventListener('waiting', () => {
    //   console.log('waiting');
    //   clearTimeout(waiting);
    //   waiting = setTimeout(() => {
    //     console.log('reset');
    //     firstSeek = true;
    //     player.source = source;
    //   }, 15000);
    // });
  }, [isLoggedIn]);

  return <video className="player" id="player" controls={true} autoPlay playsInline />;
}

export default HLSPlayer;
